import { Component } from '@angular/core';
import { getNestedValue } from '../../util/table-v2.utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../service";
import * as i2 from "primeng/progressspinner";
import * as i3 from "../../../../basic-features/input-v2/input-v2.component";
/**
 * @deprecated use v3 version of this component instead
 */
function InputRendererComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-input-v2", 3);
    i0.ɵɵlistener("valueChanged", function InputRendererComponent_Conditional_1_Template_geaui_input_v2_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.value = $event);
    })("focusOut", function InputRendererComponent_Conditional_1_Template_geaui_input_v2_focusOut_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onHandleValueChanged());
    })("keyUpEnter", function InputRendererComponent_Conditional_1_Template_geaui_input_v2_keyUpEnter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onHandleValueChanged());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("initialValue", ctx_r1.initialValue)("type", ctx_r1.config.type);
  }
}
function InputRendererComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-progressSpinner", 2);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "table-edit-loading-spinner");
  }
}
export class InputRendererComponent {
  destroyed;
  tableService;
  rowData;
  columnKey;
  config;
  tableId;
  initialValue = null;
  value = null;
  loading = false;
  getNestedValue = getNestedValue;
  constructor(destroyed, tableService) {
    this.destroyed = destroyed;
    this.tableService = tableService;
  }
  ngOnInit() {
    this.initialValue = this.getInitialValue();
    this.value = this.initialValue;
    this.tableService.cellLoading.pipe(takeUntilDestroyed(this.destroyed), filter(event => event.tableId === this.tableId && event.rowData === this.rowData && event.column === this.columnKey)).subscribe(event => {
      this.loading = event.loading;
    });
  }
  getInitialValue() {
    if (!this.rowData || !this.columnKey) {
      return null;
    }
    return this.getNestedValue(this.rowData, this.columnKey);
  }
  onHandleValueChanged() {
    if (!this.tableId || !this.columnKey || !this.rowData) {
      return;
    }
    if (this.rowData[this.columnKey] == this.value) {
      return;
    }
    this.tableService.publishColumnChange(this.tableId, this.columnKey, this.value, this.rowData);
  }
  static ɵfac = function InputRendererComponent_Factory(t) {
    return new (t || InputRendererComponent)(i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i1.TableServiceV2));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InputRendererComponent,
    selectors: [["geaui-input-renderer"]],
    decls: 3,
    vars: 1,
    consts: [[1, "checkbox-container"], [3, "initialValue", "type"], [1, "progress-spinner", 3, "styleClass"], [3, "valueChanged", "focusOut", "keyUpEnter", "initialValue", "type"]],
    template: function InputRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, InputRendererComponent_Conditional_1_Template, 1, 2, "geaui-input-v2", 1)(2, InputRendererComponent_Conditional_2_Template, 1, 1, "p-progressSpinner", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.loading ? 1 : 2);
      }
    },
    dependencies: [i2.ProgressSpinner, i3.InputV2Component],
    styles: [".checkbox-container[_ngcontent-%COMP%]{overflow:hidden}.checkbox-container[_ngcontent-%COMP%]   .progress-spinner[_ngcontent-%COMP%]{padding-left:16px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InputRendererComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-input-renderer',
      template: "<div class=\"checkbox-container\">\n  @if (!loading) {\n    <geaui-input-v2\n      [initialValue]=\"initialValue\"\n      [type]=\"config.type\"\n      (valueChanged)=\"value = $event\"\n      (focusOut)=\"onHandleValueChanged()\"\n      (keyUpEnter)=\"onHandleValueChanged()\">\n    </geaui-input-v2>\n  } @else {\n    <p-progressSpinner class=\"progress-spinner\" [styleClass]=\"'table-edit-loading-spinner'\" />\n  }\n</div>\n",
      styles: [".checkbox-container{overflow:hidden}.checkbox-container .progress-spinner{padding-left:16px}\n"]
    }]
  }], () => [{
    type: i0.DestroyRef
  }, {
    type: i1.TableServiceV2
  }], null);
})();
